/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPersonsPersonIdImpersonateV2Request
 */
export interface PostPersonsPersonIdImpersonateV2Request {
    /**
     * 
     * @type {string}
     * @memberof PostPersonsPersonIdImpersonateV2Request
     */
    target_url: string;
}

/**
 * Check if a given object implements the PostPersonsPersonIdImpersonateV2Request interface.
 */
export function instanceOfPostPersonsPersonIdImpersonateV2Request(value: object): value is PostPersonsPersonIdImpersonateV2Request {
    if (!('target_url' in value) || value['target_url'] === undefined) return false;
    return true;
}

export function PostPersonsPersonIdImpersonateV2RequestFromJSON(json: any): PostPersonsPersonIdImpersonateV2Request {
    return PostPersonsPersonIdImpersonateV2RequestFromJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonateV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsPersonIdImpersonateV2Request {
    if (json == null) {
        return json;
    }
    return {
        
        'target_url': json['target_url'],
    };
}

export function PostPersonsPersonIdImpersonateV2RequestToJSON(json: any): PostPersonsPersonIdImpersonateV2Request {
    return PostPersonsPersonIdImpersonateV2RequestToJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonateV2RequestToJSONTyped(value?: PostPersonsPersonIdImpersonateV2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_url': value['target_url'],
    };
}

